import React, { useEffect, useState } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { Container, CircularProgress, Typography,Box,Button,Alert } from '@mui/material';
import { db } from '../firebase';

const Resume = () => {
    const [resumeUrl, setResumeUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
  
    useEffect(() => {
      const fetchResumeUrl = async () => {
        try {
          const resumeRef = doc(db, 'config', 'resume');
          const resumeDoc = await getDoc(resumeRef);
          
          if (resumeDoc.exists()) {
            setResumeUrl(resumeDoc.data().downloadURL);
          } else {
            console.log('No resume document found');
            setError('Resume not found. Please check back later.');
          }
        } catch (err) {
          console.error('Error fetching resume:', err);
          if (err.code === 'permission-denied') {
            setError('Unable to access resume at this time. Please try again later.');
          } else if (err.code === 'unavailable') {
            setError('Service temporarily unavailable. Please check your internet connection.');
          } else {
            setError('Unable to load resume. Please refresh the page or try again later.');
          }
        } finally {
          setLoading(false);
        }
      };
  
      fetchResumeUrl();
    }, []);
  
    if (loading) {
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            minHeight: 'calc(100vh - 64px)' // Adjust based on your navbar height
          }}
        >
          <CircularProgress />
        </Box>
      );
    }
  
    if (error) {
      return (
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            minHeight: 'calc(100vh - 64px)'
          }}
        >
          <Alert 
            severity="error" 
            action={
              <Button color="inherit" size="small" onClick={() => window.location.reload()}>
                Retry
              </Button>
            }
          >
            <Typography>{error}</Typography>
          </Alert>
        </Box>
      );
    }
  
    return (
      <Box
        sx={{
          height: 'calc(100vh - 64px)', // Adjust based on your navbar height
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.default',
          overflow: 'hidden'
        }}
      >
        {resumeUrl ? (
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              '& iframe': {
                border: 'none',
                width: '100%',
                height: '100%',
                display: 'block'
              }
            }}
          >
            <iframe
              src={resumeUrl}
              title="Resume"
              allowFullScreen
            />
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}
          >
            <Alert severity="info">No resume is currently available.</Alert>
          </Box>
        )}
      </Box>
    );
  };
  
  export default Resume;